'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardMediaStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  theme: _propTypes2.default.object
};

/** Styles */
var CardMediaStyled = exports.CardMediaStyled = _styledComponents2.default.div.withConfig({
  displayName: 'CardMediaStyled'
})(['display:flex;flex-direction:column;justify-content:flex-end;background-position:center center;background-repeat:no-repeat;background-size:cover;position:relative;']);

CardMediaStyled.propTypes = propTypes;
CardMediaStyled.displayName = 'CardMediaStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-card/dist/CardMedia/styles/CardMediaStyled.js
// module id = 96
// module chunks = 0